<template>
<v-form v-if="user.displayName!=''"
  ref="form"
  v-model="valid">
  <YourLink :uid="this.user.uid"/>
  <v-container>
    <v-text-field
      label="Nome"
      outlined
      v-if="this.clickOnReviewMeByMovies"
      v-model="Movie.name"
      :disabled="isPreExistentURL"
      >
    </v-text-field>
      <v-autocomplete
        v-else
        name="Name"
        label="Nome"
        :loading="isLoading"
        :items="moviesnames"
        v-model="Movie.name"
        @focus="search"
        @change="getClientSideMovieByName"
        :rules="[rules.required]"
        :disabled="isPreExistentURL"
        placeholder="Nome do Filme ou série" outlined
        return-object>
        <template slot="selection" slot-scope="data">
                <v-avatar tile>
                  <img :src="streamingImage[data.item.site]">
                </v-avatar>
                <div> {{ data.item.text }}
                </div>
          </template>
          <template slot="item" slot-scope="data">
            <v-list-item-avatar tile name="data.item.text">
              <v-img
                contain width="65" height="65"
                :src="streamingImage[data.item.site]"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title> {{ data.item.text }}
              </v-list-item-title>
            </v-list-item-content>
      </template>
      </v-autocomplete>
      <v-text-field
        v-model="Movie.URL"
        label="URL"
        placeholder="Cole aqui a URL do vídeo"
        outlined
        required
        :disabled="isPreExistentURL"
        @change="getClientSideMovie"
        ></v-text-field>
      <v-select
      :items="Types"
      v-model="Movie.type"
      label="Tipo"
      required
      :disabled="isPreExistentURL"
      placeholder="Filme/Série/Documentário" outlined>
      </v-select>
      <v-select
        :items="Sites"
        label="Site"
        v-model="Movie.site"
        required
        :disabled="isPreExistentURL"
        placeholder="Slecione o Site" outlined></v-select>
      <v-rating
      v-model="UserRate.rate"
      hover></v-rating>
      <v-textarea
        counter="140"
        v-model="UserRate.description"
        label="Comentário adicional"
        placeholder="Caso deseje descreva o que achou do filme em poucas palvras."
        :rules="[rules.length(140)]"
        outlined
        ></v-textarea>
      <v-btn :disabled="!valid" @click="save">Submit</v-btn>
  </v-container>
</v-form>
</template>

<script>
import YourLink from './YourLink.vue';

const _ = require('underscore');
const amazon = require('@/assets/amazon.jpg');
const netflix = require('@/assets/netflix.jpg');

let db = {};
let firebase = {};

export default {
  name: 'Form',
  data() {
    return {
      Movie: {
        URL: '',
        name: '',
        type: '',
        site: '',
        UsersRate: [],
      },
      UserRate: {
        id: '',
        name: '',
        rate: 0,
      },
      isPreExistentURL: false,
      valid: false,
      Sites: ['YouTube', 'Prime Videos', 'Netflix'],
      Types: ['Movies', 'TVSeries', 'Documentary'],
      user: { displayName: '', photoURL: '', email: '' },
      isLoading: false,
      moviesnames: ['Movies', 'TVSeries', 'Documentary'],
      streamingImage: { 'Prime Videos': amazon, Netflix: netflix },
      url: '',
      clickOnReviewMeByMovies: false,
      rules: {
        length: (len) => (v) => (v || '').length <= len || `Você excedeu ${len} caracteres, favor diminua um pouco sua descrição`,
        required: (v) => !!v || 'Este campo é de preenchimento obrigatório',
        requiredrate: (v) => v === 0 || 'Este campo é de preenchimento obrigatório',
      },
    };
  },
  components: {
    YourLink,
  },
  mounted() {
    firebase = this.$firebase;
    db = firebase.firestore();
    if (this.$route.params.url) {
      const url = atob(this.$route.params.url);
      this.clickOnReviewMeByMovies = true;
      this.getClientSideMovie(url);
    }
  },
  created() {
    this.$firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
        this.url = `${window.location.origin}/movies/${user.uid}`;
      }
    });
  },
  methods: {
    save() {
      this.UserRate.id = this.user.uid;
      this.UserRate.name = this.user.displayName;
      this.UserRate.email = this.user.email;
      this.UserRate.date = new Date();
      this.Movie.lastRateDate = new Date();
      if (this.Movie.UsersRate === undefined) this.Movie.UsersRate = {};
      this.Movie.UsersRate[this.UserRate.id] = this.UserRate;
      this.Movie.UserRateCount = Object.keys(this.Movie.UsersRate).length;
      const Movieid = this.Movie.URL.replace(/\//g, '');
      db.collection('Movie').doc(Movieid).set(this.Movie);
      this.$refs.form.reset();
      this.isPreExistentURL = false;
      this.UserRate.rate = 0;
      if (this.clickOnReviewMeByMovies) this.$router.go(-1);
    },
    getClientSideMovie(movie) {
      let url = '';
      if (movie.includes('//www.netflix.com/')) {
        url = this.getNetflixURL(movie);
        this.Movie.site = 'Netflix';
      } else if (movie.includes('//www.primevideo.com')) {
        url = this.getPrimeVideos(movie);
        this.Movie.site = 'Prime Videos';
      } else {
        url = movie;
        alert('URL de canal desconhecido');
      }
      this.Movie.URL = url;
      const Movieid = url.replace(/\//g, '');
      const ref = db.collection('Movie').doc(Movieid);
      const unsubscribe = ref.onSnapshot((docs) => {
        if (docs.data() !== undefined) {
          this.Movie = docs.data();
          this.isPreExistentURL = true;
          if (this.Movie.UsersRate !== undefined
              && this.Movie.UsersRate[this.user.uid] !== undefined) {
            this.UserRate = this.Movie.UsersRate[this.user.uid];
          }
          if (this.UserRate === undefined) {
            this.UserRate = {
              id: '',
              name: '',
              rate: 0,
            };
          }
        }
        unsubscribe();
      },
      (err) => {
        console.log(err);
      });
    },
    getNetflixURL(movie) {
      let finalPosition = movie.indexOf('?');
      console.log(movie);
      if (finalPosition === -1) finalPosition = movie.length;
      const netflixId = movie.substring(movie.lastIndexOf('/') + 1, finalPosition);
      if (netflixId.length !== 8) alert('URL não identifica um Filme série ou documentário no Netflix');
      return `https://www.netflix.com/watch/${netflixId}`;
    },
    getPrimeVideos(movie) {
      console.log(movie);
      const primeid = movie.substring(movie.indexOf('/detail/') + 8).split('/')[0];
      if (primeid.length !== 26) alert('URL não identifica um Filme série ou documentário no Amazon Prime Videos');
      return `https://www.primevideo.com/detail/${primeid}`;
    },
    search() {
      this.isLoading = true;
      this.moviesnames = [];
      const ref = db.collection('MoviesNamesIdx').doc('moviesnames1');
      const unsubscribe = ref.onSnapshot((mvlis) => {
        if (mvlis.data() !== undefined) {
          this.moviesnames = _.sortBy(mvlis.data().names, 'text');
        }
        this.isLoading = false;
        unsubscribe();
      },
      (err) => {
        console.log(err);
      });
    },
    getClientSideMovieByName(moviename) {
      db.collection('Movie').where('name', '==', moviename.text).get()
        .then((docs) => {
          docs.forEach((doc) => {
            const movie = doc.data();
            this.getClientSideMovie(`${movie.URL}`);
          });
        },
        (err) => {
          console.log(err);
        });
    },
  },
};
</script>
